var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('app-form',{on:{"submit":function($event){$event.preventDefault();return _vm.advanceStep.apply(null, arguments)}}},[_c('marketing-email-form-models',{on:{"selected":_vm.setInitialModel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }